const buildSelectOptions = (options, keyName) => {
  if (!options || !options.length) return [];
  const parsedOptions = options.map(option => {
    const { code, name } = option;
    if (keyName) return [option[keyName], name];
    if (!code) return [name, name];
    return [code, name];
  });
  parsedOptions.unshift(['', 'Please Choose']);
  return parsedOptions;
};

export default buildSelectOptions;
